import { find, prop, propEq } from 'ramda'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import LabeledValue from '@/components/labeled-value'
import { isNullOrEmpty } from '@/utils'
import formatDate from '@/utils/format-date'
import { formatPhone } from '@/utils/format-phone'

const NoteText = styled.p`
  margin: 20px 0 0;
`

const CustomTextField = ({ item, value }) => {
  const { t, i18n } = useTranslation()

  const labelKey = `b.contract.view.${item.name}.label`
  const labelTranslated = i18n.exists(labelKey) ? t(labelKey) : item.label

  const formatValue = val => {
    switch (item.input_type) {
      case 'dropdown':
        return prop('label', find(propEq('value', val))(item.choices))
      case 'phone_number':
        return formatPhone(val)
      case 'date':
        return formatDate(val, 'YYYY/MM/DD')
      default:
        return val
    }
  }

  return (
    <>
      <LabeledValue label={labelTranslated} value={formatValue(value)} />
      {item.note && <NoteText>{item.note}</NoteText>}
    </>
  )
}

const renderCustomField = (item, contract) => {
  const customFieldValue = prop(
    'field_value',
    find(propEq('field_txt_id', item.name), contract.custom_fields)
  )

  if (isNullOrEmpty(customFieldValue)) return null

  return <CustomTextField key={item.name} item={item} value={customFieldValue} />
}

export default renderCustomField
